import React, { useState } from 'react';
import { AccordionStackable } from 'ui/AccordionStackable/AccordionStackable';
import FluidButton from 'ui/FluidButton';
import { SvgIcon } from 'ui/SvgIcon';
import ExclamationCircleIcon from 'ui/Icons/tabler/exclamation-circle.component.svg';
import InfoCircleIcon from 'ui/Icons/tabler/info-circle.component.svg';
import { TCurrencyCode } from 'interfaces';
import { IPurchaseOrderSearchDueDate } from 'services/BookingManagerApi/types/PurchaseOrdersSearchResponse';
import { IHeadlineLineItemBreakdownExchangeRate } from 'services/BookingManagerApi/types/HeadlineLineItemBreakdown';
import { InvoiceForm } from './InvoiceForm';

interface IInvoiceSectionProps {
  file: File | null;
  onOpenUploadModal: () => void;
  poCurrencySymbol: string;
  poBookingCurrency: TCurrencyCode;
  poBookingTotalCents: number;
  poDueDates: IPurchaseOrderSearchDueDate[];
  exchangeRate: IHeadlineLineItemBreakdownExchangeRate | undefined;
  bookingUuid: string;
  purchaseOrderUuid: string;
  supplierCode: string | null;
}

export const InvoiceSection = ({
  file,
  onOpenUploadModal,
  poCurrencySymbol,
  poBookingCurrency,
  poBookingTotalCents,
  poDueDates,
  exchangeRate,
  bookingUuid,
  purchaseOrderUuid,
  supplierCode,
}: IInvoiceSectionProps) => {
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);

  return (
    <AccordionStackable
      summary={
        <div className="flex items-center gap-[10px] grow">
          <span className="font-pt-sans font-bold text-[17px] text-black leading-[1.294]">
            Invoice Details
          </span>
          <span className="flex items-center gap-[3px] px-[5px] py-[5px] rounded-[4px] bg-yellow-advert-light">
            <SvgIcon
              IconComponent={ExclamationCircleIcon}
              className="w-[20px] h-[20px] fill-yellow-advert"
            />
            <span className="font-pt-sans text-[15px] text-status-requested leading-[1.294]">
              Reviewing
            </span>
          </span>
          <SvgIcon
            IconComponent={InfoCircleIcon}
            className="w-[20px] h-[20px] fill-gray-80"
          />
        </div>
      }
      isOpen={isInvoiceOpen}
      onToggle={setIsInvoiceOpen}
      wrapperClassName="!border-0"
      buttonClassName="!px-0 !py-3"
      contentWrapperClassName="!px-0 !py-0"
    >
      {!file && (
        <div className="py-[20px]">
          <FluidButton type="secondary" onClick={onOpenUploadModal}>
            Upload File
          </FluidButton>
        </div>
      )}

      {file && (
        <InvoiceForm
          file={file}
          poCurrencySymbol={poCurrencySymbol}
          poBookingCurrency={poBookingCurrency}
          poBookingTotalCents={poBookingTotalCents}
          poDueDates={poDueDates}
          exchangeRate={exchangeRate}
          bookingUuid={bookingUuid}
          purchaseOrderUuid={purchaseOrderUuid}
          supplierCode={supplierCode}
        />
      )}
    </AccordionStackable>
  );
};
